import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }
  private loading = signal(false);

  show() { this.loading.set(true); }
  hide() { this.loading.set(false); }
  isLoading() { return this.loading(); }
}
